
import { mapState, mapMutations } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: Boolean,
    item: {
      default: () => {},
      type: Object
    },
    editingInfo: {
      default: () => {},
      type: Object
    }
  },
  beforeMount() {
    if (this.editingInfo) {
      this.variant.name = this.editingInfo.name;
      this.variant.price = this.editingInfo.price;
    }
  },
  data() {
    return {
      valid: false,
      variant: {
        name: "",
        price: ""
      },
      isAddNewVariantEnabled: false
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadList"]),
    variantLabel() {
      if (this.editingInfo) {
        return `Modify Variant ${this.variant.name}`;
      } else if (this.item) {
        return `Add Variant for ${this.item.item_name}`;
      } else {
        return "Add Variant";
      }
    }
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),
    noNumericName(value) {
      const regex = /^\s*\d+\s*$/;
      return (
        !regex.test(value) || "Variant name cannot be only numeric characters."
      );
    },

    submitSelection() {
      const index = this.getMenuUploadItemIndex(
        this.menuUploadList,
        this.item.id
      );
      if (index === -1) return;
      const menuUploadList = JSON.parse(JSON.stringify(this.menuUploadList));
      const currentVariants = menuUploadList[index].variants || [];

      if (this.editingInfo) {
        const variantIndex = currentVariants.findIndex(
          (variant) => variant.name === this.editingInfo.name
        );

        if (variantIndex !== -1) {
          currentVariants[variantIndex] = { ...this.variant };
        } else {
          currentVariants.push(this.variant);
        }
      } else {
        currentVariants.push(this.variant);
      }
      this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
        index: index,
        propName: "variants",
        propValue: currentVariants
      });
      if (
        this.item.package_charge &&
        this.item.package_charge > this.getApplicableMaxCharge(this.item)
      ) {
        this.$emit("update-packaging-charge-dialog");
      } else {
        if (this.isAddNewVariantEnabled) {
          this.$emit("open-add-new-variant-dialog");
        } else {
          this.$emit("close-dialog");
        }
      }
    }
  }
};
